require('./component/search');
require('./component/morenews');
require('./component/bi');
require('./component/hao');
require('./component/rank');
require('./component/backtotop');


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0